import { z } from 'zod';

const githubRepositoryNameRegex = /^[a-zA-Z0-9-_. ]+$/;

export const githubRepositoryNameSchema = z
  .string()
  .refine((value) => !!value.trim(), { message: 'Cannot be empty' })
  .refine((value) => githubRepositoryNameRegex.test(value.trim()), { message: 'Has invalid characters' })
  .refine((value) => !(value.trim().startsWith('-') || value.trim().startsWith('_') || value.trim().startsWith('.')), {
    message: 'Must start with alphanumeric',
  })
  .refine((value) => !(value.trim().endsWith('-') || value.trim().endsWith('_') || value.trim().endsWith('.')), {
    message: 'Must end with alphanumeric',
  })
  .refine((value) => value.trim().length <= 100, { message: 'Must be under 100 characters' });

export const githubRepositoryOwnerSchema = z.string().refine((value) => !!value.trim(), { message: 'Please pick an organization' });
